import { MouseEventHandler } from "react";

import NextButton, { TypeButton } from "../../next/NextButton";

declare type Props = {
  onClick?: MouseEventHandler<HTMLElement> | undefined;
  type?: TypeButton | undefined;
};

const RetryButton = ({ onClick, type = "error" }: Props) => {
  return <NextButton label="Reintentar" icon="arrow-rotate-right" onClick={onClick} type={type} />;
};

export default RetryButton;
